import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";

export const selectMapQuery =
    createSelector(
        [
            (state:RootState) => state.map.mapQueries,
            (_:any, index: number)  => index
        ],
        (mapQueries,index) => mapQueries[index]
    );